import { TableFilterType } from 'features/TableFilter';
import { getServerDateWithMinuteTimeFormat } from 'shared/utils/helpers/getDateFormat';

interface HistoryFilters {
  warehouseId?: string | string[];
  startDate?: string;
  endDate?: string;
  actionName?: string | string[];
}

export const transformHistoryFilters = ({ selectedWarehouses, startDate, endDate, actionTypes }: TableFilterType): HistoryFilters => {
  const warehouseId = selectedWarehouses?.value?.length ? selectedWarehouses.value : undefined;

  return {
    warehouseId,
    startDate: getServerDateWithMinuteTimeFormat(startDate?.value),
    endDate: getServerDateWithMinuteTimeFormat(endDate?.value),
    actionName: actionTypes?.value || undefined,
  };
};
